import axios from 'axios'
import {errorHandlingAppSync} from '../services/helpers'

export default {
  namespaced: true,
  state: {
    token: null,
    siemensId: null,
    lastLogin: null,
    firstName: '',
    lastName: '',
    credits: [],
    subscription: null,
    isGovcloudUser: false,
    loaded: false,
    isOnboard: null,
    isPassWasChangedCookieName: 'isPassWasChanged'
  },
  mutations: {
    'SET_TOKEN' (state, token) {
      state.token = token
    },
    'SET_SIEMENS_ID' (state, id) {
      state.siemensId = id
    },
    'SET_LAST_LOGIN' (state, lastLogin) {
      state.lastLogin = lastLogin
    },
    'SET_FIRST_NAME' (state, name) {
      state.firstName = name
    },
    'SET_LAST_NAME' (state, name) {
      state.lastName = name
    },
    'SET_CREDITS' (state, credits) {
      state.credits = credits
    },
    'SET_SUBSCRIPTION' (state, subscription) {
      state.subscription = subscription
    },
    'SET_GOVCLOUD' (state, isGovcloudUser) {
      state.isGovcloudUser = isGovcloudUser
    },
    'SET_USER_EMAIL' (state, email) {
      state.email = email
    },
    'SET_USER_LOADED' (state) {
      state.loaded = true
    },
    'SET_ONBOARD' (state, onBoard) {
      state.isOnboard = onBoard
    }
  },
  getters: {
    subscriptionExpiration (state) {
      const subscription = state.subscription
      if (subscription) {
        const expDate = new Date(subscription.activeUntil)
        if (expDate > new Date()) {
          return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][expDate.getMonth()] + ` ${expDate.getDate()}, ${expDate.getFullYear()}`
        }
      }
      return null
    }
  },
  actions: {
    loadUser ({rootState, state, commit}) {
      return axios.post(
        process.env.APPSYNC_URL,
        {
          query:
            `query {
              user: getUser (siemensUserId: "${state.siemensId}") {
                firstName
                lastName
                isGovcloudUser
                email
                userOnboardingComplete
                subscription {
                  id
                  activeUntil
                }
                siemensUserId
              }
            }`
        },
        {
          headers: {
            Authorization: `${state.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
        .then(response => {
          response = errorHandlingAppSync(response)
          const user = response.data.user
          if (user) {
            commit('SET_FIRST_NAME', user.firstName)
            commit('SET_LAST_NAME', user.lastName)
            commit('SET_SUBSCRIPTION', user.subscription)
            commit('SET_GOVCLOUD', user.isGovcloudUser)
            commit('SET_USER_EMAIL', user.email)
            commit('SET_ONBOARD', user.userOnboardingComplete)
            commit('SET_USER_LOADED')
          }
        })
    },

    refreshCredits ({rootState, state, commit}) {
      return axios.post(
        process.env.APPSYNC_URL,
        {
          query:
            `query {
              user: getUser (siemensUserId: "${rootState.user.siemensId}") {
                subscription {
                  id
                  activeUntil
                }
              }
            }`
        },
        {
          headers: {
            Authorization: `${state.token}`,
            'Content-Type': 'application/json'
          }
        }
      ).then((response) => {
        response = errorHandlingAppSync(response)
        commit('SET_SUBSCRIPTION', response.data.user.subscription)
      })
    },

    createUser ({rootState, commit}, payload) {
      return axios.post(
        `${rootState.config.API_URL}/users/create`, payload,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => {
        commit('SET_SIEMENS_ID', response.data.siemensUserId)
      })
    },

    onboarding ({rootState, state, commit}, payload) {
      // check user onboard status
      return axios.post(
        `${rootState.config.API_URL}/users/onboarding`, payload,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        commit('SET_GOVCLOUD', response.data.isGovcloudUser)
        commit('SET_ONBOARD', response.data.userOnboardingComplete)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js